import React from 'react';
import { useDispatch } from 'react-redux';
import { Container, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';

import { useFilterContext } from '../FilterProvider';
import { stateReset } from '../action';

const FilterSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { filters, updateFilters } = useFilterContext();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    updateFilters({ [name]: checked });
    dispatch(stateReset());
  };

  return (
    <Container className="shadow my-3 rounded">
      <div className="d-flex flex-column flex-lg-row justify-content-between py-3">
        <strong className="d-block me-5">{t('healthQuote.filters')}</strong>
        {map(filters, (value, key) => (
          <Form.Check
            id={key}
            key={key}
            name={key}
            checked={value}
            onChange={handleChange}
            label={t(`healthQuote.${key}`)}
          />
        ))}
      </div>
    </Container>
  );
};

export { FilterSection };
